export default __webpack_public_path__ + "static/media/FilePickerIcon.9d7dbfa2.svg";